import { useQuery } from "@tanstack/react-query";
import { api } from "../../config";

function useGetSellerCampaigns(params, enabled) {
    const queryParams = {
        limit: 20,
        page: 1,
        ...params,
    };
    
    if (queryParams.limit > 50) {
        queryParams.limit = 50;
    }
    
    return useQuery({
        queryFn: async () => {
            const res = await api.get(`/promotions/campaigns`, { params: queryParams });
            return res.data;
        },
        queryKey: ['seller-campaigns', queryParams],
        enabled,
        retry: false,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    })
}

function useGetCampaignDetails(promotionId, params, enabled) {
    return useQuery({
        queryFn: async () => {
            const res = await api.get(`/promotions/campaigns/${promotionId}`, { params });
            return res.data;
        },
        queryKey: ['campaign-details', promotionId, params],
        enabled,
        retry: false,
        refetchOnWindowFocus: false
    })
}

function useGetCampaignItems(promotionId, params, enabled, promotionType) {
    const queryParams = {
        limit: 12,
        ...params,
        ...(promotionType ? { promotion_type: promotionType } : {})
    };
    
    return useQuery({
        queryFn: async () => {
            const res = await api.get(`/promotions/campaigns/${promotionId}/items`, { params: queryParams });
            return res.data;
        },
        queryKey: ['campaign-items', promotionId, queryParams],
        enabled,
        retry: false,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    })
}

function useGetItemCampaigns(itemId, params, enabled) {
    return useQuery({
        queryFn: async () => {
            const res = await api.get(`/promotions/items/${itemId}/campaigns`, { params });
            return res.data;
        },
        queryKey: ['item-campaigns', itemId, params],
        enabled,
        retry: false,
        refetchOnWindowFocus: false
    })
}

function useGetCandidateInformation(candidateId, params, enabled) {
    return useQuery({
        queryFn: async () => {
            const res = await api.get(`/promotions/candidates/${candidateId}`, { params });
            return res.data;
        },
        queryKey: ['candidate-information', candidateId, params],
        enabled,
        retry: false,
        refetchOnWindowFocus: false
    })
}

function useGetOfferInformation(offerId, params, enabled) {
    return useQuery({
        queryFn: async () => {
            const res = await api.get(`/promotions/offers/${offerId}`, { params });
            return res.data;
        },
        queryKey: ['offer-information', offerId, params],
        enabled,
        retry: false,
        refetchOnWindowFocus: false
    })
}

function useCheckSellerExclusionStatus(params, enabled) {
    return useQuery({
        queryFn: async () => {
            const res = await api.get(`/promotions/exclusion-list/seller`, { params });
            return res.data;
        },
        queryKey: ['seller-exclusion-status', params],
        enabled,
        retry: false,
        refetchOnWindowFocus: false
    })
}

function useCheckItemExclusionStatus(itemId, params, enabled) {
    return useQuery({
        queryFn: async () => {
            const res = await api.get(`/promotions/exclusion-list/items/${itemId}`, { params });
            return res.data;
        },
        queryKey: ['item-exclusion-status', itemId, params],
        enabled,
        retry: false,
        refetchOnWindowFocus: false
    })
}

function useGetCampaignCandidates(campaignId, params, enabled) {
    return useQuery({
        queryFn: async () => {
            const res = await api.get(`/promotions/campaigns/${campaignId}/candidates`, { params });
            return res.data;
        },
        queryKey: ['campaign-candidates', campaignId, params],
        enabled,
        retry: false,
        refetchOnWindowFocus: false
    })
}

function useCampaignMetrics(enabled = true) {
    return useQuery({
        queryFn: async () => {
            const res = await api.get('/promotions/campaigns/metrics');
            return res.data;
        },
        queryKey: ['campaign-metrics'],
        enabled,
        retry: false,
        refetchOnWindowFocus: false
    })
}

function useListExportFiles(params, enabled = true) {
    return useQuery({
        queryFn: async () => {
            const res = await api.get('/promotions/exports/files', { params });
            return res.data;
        },
        queryKey: ['export-files', params],
        enabled,
        retry: false,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    })
}

export {
    useListExportFiles,
    useGetSellerCampaigns,
    useGetCampaignDetails,
    useGetCampaignItems,
    useGetItemCampaigns,
    useGetCandidateInformation,
    useGetOfferInformation,
    useCheckSellerExclusionStatus,
    useCheckItemExclusionStatus,
    useGetCampaignCandidates,
    useCampaignMetrics
}